import { Button } from '@hologram-dimension/button';
import { Icon } from '@hologram-dimension/icon';
import { FC } from 'react';

import AutoComplete from './autocomplete';

interface SearchAutoCompleteProps {
  value: string;
  onChange: AnyFunction;
  showClearButton?: boolean;
  topics: Array<any>;
}

const SearchAutoComplete: FC<SearchAutoCompleteProps> = ({
  value,
  onChange = () => {},
  showClearButton = true,
  topics,
}) => (
  <div
    className="SearchButton autocomplete"
    onSubmit={(e) => {
      e.preventDefault();
    }}
  >
    <div className="grid-row vertical-align">
      <Icon name="Search" fill="DdsColorInteractivePrimaryDefault" />
      <AutoComplete
        suggestions={topics.map((suggestion) => ({ name: suggestion }))}
        onChange={onChange}
        value={value}
        allowNew
        allowDuplicates
        autofocus={false}
        autoresize
        placeholder="Search by topics published"
      />
      {showClearButton && (
        <Button variant="tertiary" iconStart="Close" onClick={() => onChange('')} />
      )}
    </div>
  </div>
);

export default SearchAutoComplete;
